/**
 * Texto de confirmación al cambiar el alta del proveedor.
 * Activar no publica fichas. Desactivar no las retira de la tienda.
 */

/** Null si se puede sincronizar. La previsualización no usa este texto. */
export function syncNowBlockedReason(isActive: boolean): string | null {
    if (isActive) return null;
    return 'El proveedor está inactivo. Actívalo para sincronizar. La previsualización no escribe nada y sigue disponible.';
}

export function supplierActivityLabel(action: string): string {
    if (action === 'activated') return 'Proveedor activado';
    if (action === 'deactivated') return 'Proveedor desactivado';
    return 'Cambio de alta';
}

export function supplierActiveConfirm(input: {
    name: string;
    nextActive: boolean;
    manualCatalog: boolean;
}): { title: string; description: string; confirmLabel: string } {
    if (input.nextActive) {
        const schedule = input.manualCatalog
            ? 'No entra en el cron: el catálogo se aplica al pulsar Sincronizar ahora.'
            : 'También entra en la sincronización automática.';
        return {
            title: `Activar ${input.name}`,
            description: `Podrás sincronizar su catálogo. Las fichas no se publican: cada una sigue inactiva hasta que la publiques. ${schedule}`,
            confirmLabel: 'Activar',
        };
    }
    return {
        title: `Desactivar ${input.name}`,
        description: 'Deja de poder sincronizarse y sale del cron. Las fichas ya publicadas siguen a la venta. Sus plazos de marca dejan de usarse al calcular el envío.',
        confirmLabel: 'Desactivar',
    };
}
